export const E_GreenSocket_MessageTypes = {
	LOGIN: "LOGIN",
	SUBSCRIBE: "SUBSCRIBE",
	UNSUBSCRIBE: "UNSUBSCRIBE",
	SYNC: "SYNC",
	ERROR: "ERROR",
	MESSAGE: "MESSAGE",
};
